import { z } from 'zod'

export const ViewLine = z.object({ speaker: z.string().nullable(), text: z.string() })
export const ViewChoice = z.object({ index: z.number().int().nonnegative(), text: z.string() })

/** Tutto ciò che il client vede di una scena: mai lo stato ink né i rami futuri. */
export const SceneView = z.object({
  sceneId: z.string().nullable(),
  lines: z.array(ViewLine),
  choices: z.array(ViewChoice),
  momentId: z.string().nullable(),
  poses: z.record(z.string(), z.string()),
  ended: z.boolean(),
})
export type SceneView = z.infer<typeof SceneView>

export const TimelineResponse = z.object({
  timelineId: z.uuid(),
  version: z.number().int().positive(),
  view: SceneView,
})
export type TimelineResponse = z.infer<typeof TimelineResponse>

export const ChoiceRequest = z.object({
  index: z.number().int().nonnegative(),
  expectedVersion: z.number().int().positive(),
})
export type ChoiceRequest = z.infer<typeof ChoiceRequest>

export const VersionConflictBody = z.object({
  error: z.literal('version_conflict'),
  version: z.number().int().positive(),
  view: SceneView,
})
export type VersionConflictBody = z.infer<typeof VersionConflictBody>
